<template>
    <div class="quickpay-partners-loader">
        <CompassSkeleton class="quickpay-partners-loader__title" size="large" />
        <CompassSkeleton class="quickpay-partners-loader__description" />
        <div class="quickpay-partners-loader__grid">
            <div v-for="index in 3" :key="index" class="quickpay-partners-loader__card">
                <CompassSkeleton class="quickpay-partners-loader__card-logo" variant="square" />
                <CompassSkeleton class="quickpay-partners-loader__card-name" />
                <CompassSkeleton class="quickpay-partners-loader__card-description" />
                <CompassSkeleton class="quickpay-partners-loader__card-button" size="x-large" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.quickpay-partners-loader {
    display: flex;
    flex-direction: column;

    &__title {
        width: 260px;
        margin-bottom: var(--spacing-4);
    }
    &__description {
        width: 460px;
        margin-bottom: var(--spacing-6);
    }
    &__grid {
        display: flex;
        flex-wrap: wrap;
        gap: var(--spacing-3);
    }
    &__card {
        display: flex;
        flex-direction: column;
        flex: 1 1 0;
        height: 216px;
        padding: var(--spacing-3);
        background: var(--colors-common-background-default);
        border-radius: var(--spacing-1);
        box-shadow: var(--elevation-1);
    }
    &__card-logo {
        margin-bottom: var(--spacing-3);
        :deep(.compass-skeleton__square--medium) {
            width: var(--spacing-6);
            height: var(--spacing-6);
        }
    }
    &__card-name {
        width: 80px;
        margin-bottom: var(--spacing-2);
    }
    &__card-description {
        width: 190px;
    }
    &__card-button {
        width: 100%;
        margin-top: auto;
    }
}
</style>
